import { useCallback, useState } from "react";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { ALL_INFO_RETIREMENT_STEPS, initProposition } from "../../../const/AppConst";
import useAppState from "../../../context/AppContext";
import { AppState } from "../../../context/reducers/AppReducer";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";
import { getPropositionById, getPropositionCart } from "../../../services/CustomerApiService";
import { displayRetiredSteps, getStartPageRetirement, isPropositionAfterSignature, isPropositionInDraft } from "../../../utils/dataUtils";
import { isMgpAdmin } from "../../../utils/permissionUtils";
import { extractJwtToken, hasValidateJwt } from '../../../utils/utils';
import LoaderActionComponent from "../../common/LoaderActionComponent";
import { CartCheckStepInfo } from "../../../context/model";

export default function RELoginComponent() {
  const {  
    dispatch,
  } = useAppState();


  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [initLink, setInitLink] = useState<number>(0);
  
  const [isLoading, setIsLoading] = useState(false);

  const [searchParams] = useSearchParams();
  let initToken = searchParams.get("id");
  let jwtParams = searchParams.get("token");
  let isDemoMode = searchParams.get("demo");
  let isConseiller = false;
  let stepCode = searchParams.get("step");
  const navigate = useNavigate();


  const accessWithJwt = useCallback(async () => {
    setErrorMsg(null);

    const extractedJwt = extractJwtToken(jwtParams, true);

   
    if (!extractedJwt || !hasValidateJwt(extractedJwt)) {
      setErrorMsg("Ce lien n'est pas valide. Merci de reprendre votre lien d'affiliation dans votre boite mail.");
      setInitLink(-1);
      return;
    }

    isConseiller = isMgpAdmin(extractedJwt)

    dispatch({type: 'LOGIN_RETIREMENT', id: initToken!, jwt: jwtParams!, isDemo: isDemoMode === 'true', isConseiller: isConseiller});
    try {
        let proposition = initProposition;
        let cartVal = undefined;  
        let cartInfoStep: CartCheckStepInfo | undefined = undefined;
        let currentStepPath = '' as string;
        
        if (initToken) {
            const propositionPayload = await getPropositionById(jwtParams!, initToken);
            proposition = propositionPayload.data;
            if(isPropositionAfterSignature(propositionPayload.data) && !isConseiller) {
                setErrorMsg("Votre parcours est finalisé, vous ne pouvez plus y accédez. Pour toute question complémentaire, veuillez contacter un conseiller.");
                setIsLoading(false);
                setInitLink(-1);
                return;
            };
            if(isPropositionInDraft(propositionPayload.data) && propositionPayload.data.currentStep) {
                try {
                const cartPayload = await getPropositionCart(jwtParams!, initToken);
                cartVal = cartPayload.data;
                if(cartVal?.data) {
                  let cartState:AppState = JSON.parse(cartVal?.data);

                  if(cartState.proposition) {
                    proposition = cartState.proposition;
                    if(cartState.lastStepPath) {
                        const stepFound = ALL_INFO_RETIREMENT_STEPS.find(step => step.path === cartState.lastStepPath);
                        currentStepPath = stepFound?.path??'';
                    }
                  }

                  // this object serves for displayRetiredSteps
                  cartInfoStep = {
                    requiredCNI:  proposition?.configuration?.requireIdentityDocument,
                    hasChild:  cartState?.additionalData?.hasChild,
                    hasPartner: cartState?.additionalData?.hasPartner,
                    hasOldMutual:  cartState?.updatedProposition?.hasOldMutual ?? undefined
                  }
                }
                } catch(e) {
                console.log("Error during getting cart");
                }        
            }

        }
        
        dispatch({type: 'LOAD_PROPOSITION', proposition: proposition, cartData: cartVal?.data});

        //filter unnecessary steps following CNI, beneficiary, RIA condition
        let steps = displayRetiredSteps(cartInfoStep);

        if (currentStepPath) {
          const index = steps.findIndex(step => step.path === currentStepPath);
          steps.forEach((step, i) => {
            if (i<=index) {
              step.state = "ACTIVE"
            }
          })
        }
  
        dispatch({type: "UPDATE_STEPS", steps: steps});
  
        const startPage = getStartPageRetirement(proposition, currentStepPath, stepCode, isConseiller);
        navigate({
          pathname: startPage,
          search: createSearchParams({
              id: proposition?.propositionId
          }).toString(),
        }, {replace: true});
      
   
    } catch (error) {
      console.log(error);
      setErrorMsg("Une erreur technique est survenue");
      setInitLink(-1);
    }
  }, [jwtParams]);

  




  return (
    <>

      { jwtParams && initLink === 0 && <LoaderActionComponent onLoad={accessWithJwt}/> }

      {
        errorMsg && 
        <div className='form-row mt-md'>
          <div className="form-group mw-100">  
            <p className="bg-fushia blanc p-sm">{errorMsg}</p>
          </div>
        </div>
      }
    </>
  );
}
